import request from '@/utils/request'


// 新增发票信息
export function addInvoice(data) {
  return request({
    url: '/fina/noinvoice',
    method: 'post',
    data: data
  })
}

// 修改发票信息
export function updateInvoice(data) {
  return request({
    url: '/fina/invoice',
    method: 'put',
    data: data
  })
}

// 删除发票信息
export function delInvoice(invoiceId) {
  return request({
    url: '/fina/noinvoice/' + invoiceId,
    method: 'delete'
  })
}

// 导出发票信息
export function exportInvoice(query) {
  return request({
    url: '/fina/noinvoice/export',
    method: 'get',
    params: query
  })
}

// 查询合同管理列表
export function listContract(query) {
  return request({
    url: '/fina/noinvoice/list',
    method: 'get',
    params: query
  })
}

// 查询合同管理详细
export function getNoInvoiceContract(contractId) {
  return request({
    url: '/fina/noinvoice/' + contractId,
    method: 'get'
  })
}

